/**
 * @generated SignedSource<<10ac8d3f62f6457a4825768081e1e58c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsGrid_user$data = {
  readonly serviceId: string | null;
  readonly twoTowerModelItemRecommendations: {
    readonly recommendationIds: ReadonlyArray<string>;
  } | null;
  readonly " $fragmentType": "UserRecommendationsGrid_user";
};
export type UserRecommendationsGrid_user$key = {
  readonly " $data"?: UserRecommendationsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsGrid_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserRecommendations",
      "kind": "LinkedField",
      "name": "twoTowerModelItemRecommendations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendationIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2ef40b47b8fa2609f357244900b4c8bc";

export default node;
